<template>
	<div v-if="showContent" class="padding-top-20 padding-bottom-50">
		<div class="container">
			<div class="page-content text">
				<vue-markdown>{{ content }}</vue-markdown>
			</div>
			<div class="page-content"><slot /></div>
		</div>
	</div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'

export default {
	name: 'PageContent',
	components: {
		VueMarkdown,
	},
	props: {
		content: {
			type: [String, Object],
			required: true,
		},
	},
	computed: {
		showContent() {
			return this.content
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/partials/PageContent.vue